<template>
  <div class="card">
    <div
      v-b-toggle="`collapsePhds`"
      class="card-header"
    >
      <h3
        :id="`field-3`"
        class="cart-title"
      >
        <a data-action="collapse">{{ field.label ? field.label : field.name }}</a>
      </h3>
      <b-tooltip
        :key="`field-custom-3`"
        placement="topleft"
        boundary="document"
        triggers="hover"
        :target="`field-3`"
        :title="field.tooltip"
      />
      <div class="heading-elements">
        <ul class="list-inline mb-0">
          <li>
            <a data-action="collapse"><i data-feather="chevron-down" /></a>
          </li>
          <!-- <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Edit"
              @click="redirectuser($event, [{user_id: userId}, 'researcher.phds.index'])"
            ><i data-feather="edit-3" /></a>
          </li> -->
        </ul>
      </div>
    </div>
    <b-collapse
      :id="`collapsePhds`"
      v-model="isToggled"
    >
      <div
        class="card-content"
      >
        <div class="card-body">
          <div
            v-if="loading"
            class="loading position-relative"
          >
            <div class="effect-1 effects" />
            <div class="effect-2 effects" />
            <div class="effect-3 effects" />
          </div>
          <div
            v-else
            class="row"
          >
            <div class="col">
              <ul
                v-for="phd in filteredPhds"
                :key="phd.id"
                class="abridged-cv__list"
              >
                <li>
                  <div
                    v-if="fromPromotion && convo.days > 0 && isResearcher"
                    class="form-check form-switch form-check-inline me-2"
                  >
                    <input
                      :id="'activityContent' + phd.id"
                      type="checkbox"
                      class="form-check-input"
                      :checked="selectedActivities.includes(phd.id.toString())"
                      @change="handleActivityClick(phd, $event)"
                    >
                  </div>
                  <strong>{{ phd.date_formatted }}</strong> -
                  {{ phd.content_formatted.phd_role ? phd.content_formatted.phd_role.name : '' }} - {{ phd.content_formatted.phd_type ? `(${phd.content_formatted.phd_type.name})` : '' }} - "{{ phd.content_formatted.title }}"
                  {{ phd.content_formatted.recipient_name ? ` - by: ${phd.content_formatted.recipient_name}` : '' }}{{ phd.content_formatted.host_name ? `, ${phd.content_formatted.host_name}` : '' }}{{ phd.country ? ` · ${phd.country}` : '' }}.
                  <a
                    class="ms-1 btn btn-sm bg-light-secondary"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Edit"
                    @click="redirectuser($event, [{ id: phd.id }, 'researcher.phds.edit'])"
                  ><i data-feather="edit-3" /></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BCollapse, BTooltip } from 'bootstrap-vue'

export default {
  components: {
    BCollapse,
    BTooltip,
  },
  props: {
    userId: { type: Number, required: true, default: () => {} },
    yearBetween: { type: Object, required: true, default: () => {} },
    field: { type: Object, required: true },
    promo: { type: Object, required: false, default: () => {} },
    fromPromotion: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      loading: true,
      isToggled: true,
      type: 'phds',
    }
  },
  computed: {
    ...mapGetters({
      scientificPhds: 'users/scientificPhds',
      selectedActivities: 'convo/selectedActivities',
      toggled: 'preview/toggled',
      convo: 'convo/convo',
      loggedUser: 'auth/admin',
    }),
    isResearcher() {
      return this.loggedUser.roles.includes('researcher')
    },
    filteredPhds() {
      if(this.loggedUser.roles.includes('super-admin') && this.convo.year < 2026) {
        return this.scientificPhds
      }
      
      if (this.isResearcher && (!this.fromPromotion || this.convo.year < 2026 || this.convo.days > 0)) {
        return this.scientificPhds
      }
      // For non-researchers or when in promotion mode with days <= 0, only show selected PhD theses
      return this.scientificPhds.filter(phd => this.selectedActivities.includes(phd.id.toString()))
    },
  },
  watch: {
    userId() {
      this.reloadData()
    },
    toggled() {
      if (this.toggled !== this.isToggled) {
        this.isToggled = this.toggled
      }
    },
    yearBetween() {
      this.reloadData()
    },
  },
  async mounted() {
    this.reloadData()
    if (this.fromPromotion) {
      this.loadSelectedActivities()
    }
  },
  methods: {
    async reloadData() {
      this.loading = true
      this.isToggled = this.toggled
      if (this.promo && this.promo.id && !this.promo.active_researcher) {
        await this.$store.dispatch('users/fetchUserScientificActivitiesFreezed', {
          convo: this.promo.id, userId: this.userId, yearBetween: this.yearBetween, type: this.type,
        })
      } else {
        await this.$store.dispatch('users/fetchUserScientificActivities', { userId: this.userId, yearBetween: this.yearBetween, type: this.type })
      }
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        feather.replace({
          width: 14,
          height: 14,
        })
      }, 500)
      this.loading = false
    },
    async redirectuser(event, redirection) {
      event.stopPropagation()
      this.$emit('goToIndex', redirection)
    },

    handleActivityClick(activity, event) {
      const isChecked = event.target.checked
      const isCurrentlySelected = this.selectedActivities.includes(activity.id.toString())
      const promotionDataId = isCurrentlySelected ? activity.pivot?.id : null

      this.$emit('item-selected', {
        id: promotionDataId || null,
        origenable_id: activity.id,
        type: 'App\\Models\\Activity',
        selected: isChecked,
      })
    },

    async loadSelectedActivities() {
      if (!this.fromPromotion) return

      try {
        await this.$store.dispatch('convo/fetchSelectedPromotionScientificProductions', {
          origenableType: 'App\\Models\\Activity',
          userId: this.userId,
        })
      } catch (error) {
        console.error('Error loading selected activities:', error)
      }
    },
  },
}
</script>
